module.exports = __webpack_public_path__ + "static/media/guides.6e7f1757.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/travel/guides.jpg
// module id = 742
// module chunks = 0